import { YearlyResource } from '../models/api/yearlyResource';

/**
 * Result of resolving a YearlyResource into UI-ready state. `formValues` is the
 * payload to patch into the form (saved data when present/inherited, prior-year
 * template when carried-forward, null when absent). The boolean flags drive
 * banner display in tabs.
 */
export interface ResolvedYearlyResource<T> {
  formValues: T | null;
  isPresent: boolean;
  isCarriedForward: boolean;
  isInherited: boolean;
  isAbsent: boolean;
  sourceYear?: number;
  effectiveYear?: number;
  lastYearWithData?: number;
  suggestedAction?: string;
}

export function handleYearlyResource<T, C = unknown>(
  resource: YearlyResource<T, C>
): ResolvedYearlyResource<T> {
  const isPresent = resource.state === 'present';
  const isCarriedForward = resource.state === 'carried-forward';
  const isInherited = resource.state === 'inherited';
  const isAbsent = resource.state === 'absent';

  let formValues: T | null = null;
  if (isPresent || isInherited) {
    formValues = resource.data;
  } else if (isCarriedForward && resource.carriedForward) {
    formValues = resource.carriedForward.values;
  }

  return {
    formValues,
    isPresent,
    isCarriedForward,
    isInherited,
    isAbsent,
    sourceYear: resource.carriedForward?.sourceYear,
    effectiveYear: resource.hints?.effectiveYear,
    lastYearWithData: resource.hints?.lastYearWithData,
    suggestedAction: resource.hints?.suggestedAction
  };
}
